import React from 'react';
import classNames from 'classnames';

import styles from './FormHeader.module.scss';

interface FormHeaderProps {
  title: JSX.Element | string | null;
  className?: string;
}

const FormHeader = ({ title, className }: FormHeaderProps) => (
  <div className={classNames(styles.header, className)}>{typeof title === 'string' ? <h4>{title}</h4> : title}</div>
);

export default FormHeader;
